import { ConfigStoreState, LayoutInterface, TileConfigInterfaces, TileNames } from "./config.types"

export const DEFAULT_TILE_CONFIG: {[key in TileNames]: TileConfigInterfaces} = {
  "stream": {
    "autoplay": true,
    "mute": true,
    "streamid": "nasatv_public",
    "controls": true
  },
  "liveevents": {},
  "telemetry": {
    "datapoints": [
      "USLAB000084",
      "USLAB000086",
      "RUSSEG000001",
      "TIME_000001",
      "USLAB000039",
      "USLAB000012",
      "USLAB000011",
      "USLAB000042",
      "USLAB000041",
      "USLAB000081",
      "USLAB000013",
      "USLAB000014",
      "USLAB000015",
      "USLAB000010",
      "USLAB000005",
      "USLAB000001",
      "USLAB000002",
      "USLAB000003",
      "USLAB000004",
      "S1000009",
      "P1000007",
      "USLAB000092",
      "Z1000013",
      "USLAB000095",
      "USLAB000096",
      "USLAB000097",
      "USLAB000098",
      "S0000007",
      "S0000006",
      "S0000008",
      "S0000009",
      "USLAB000025",
      "USLAB000026",
      "USLAB000027",
      "AIRLOCK000054",
      "USLAB000099",
      "USLAB000100",
      "USLAB000101",
      "CSASSRMS003",
      "CSASSRMS002",
      "USLAB000058",
      "AIRLOCK000049",
      "AIRLOCK000054",
      "S1000002",
      "P1000002",
      "S4000002",
      "S4000001",
      "S6000005",
      "S6000004",
      "P4000002",
      "P4000001",
      "P6000005",
      "P6000004",
      "S4000005",
      "S4000004",
      "S6000002",
      "S6000001",
      "P4000005",
      "P4000004",
      "P6000002",
      "P6000001",
      "CSASSRMS011"
    ],
    "highlight": true
  },
  "spacecraftmap": {
    "spacecraft": [
      "ISS (ZARYA)",
      "CSS (TIANHE)"
    ],
    "followSpacecraft": {
      "enabled": false,
      "name": "ISS (ZARYA)"
    }
  },
  "issmccmap": {},
  "": {}
}

export const DEFAULT_LAYOUTS: Array<LayoutInterface> = [
  {
    name: "Default",
    config: [
      [
        {
          "name": "stream",
          "config": {
            ...DEFAULT_TILE_CONFIG.stream,
            "streamid": "iss_dl1"
          }
        }, {
          "name": "stream",
          "config": {
            ...DEFAULT_TILE_CONFIG.stream,
            "streamid": "iss_dl6"
          }
        }
      ], [
        {
          "name": "telemetry",
          "config": DEFAULT_TILE_CONFIG.telemetry
        }, {
          "name": "spacecraftmap",
          "config": DEFAULT_TILE_CONFIG.spacecraftmap
        }
      ]
    ]
  }
]

export const DEFAULT_CONFIG: ConfigStoreState = {
  bookmarks: {},
  layouts: DEFAULT_LAYOUTS,
  activeLayoutIndex: 0,
  nextEventPopup: true,
  tourTaken: false,
  timers: {
    countdowns: []
  }
}